import { Link } from "react-router-dom";
import { Heart, ShoppingBag, X } from "lucide-react";
import { inr, usePageTitle, useShop } from "@/context/ShopContext";

export default function Wishlist() {
  usePageTitle("Wishlist");
  const { wishlist, byId, toggleWishlist, addToCart, loading } = useShop();
  const items = wishlist.map((id) => byId[id]).filter(Boolean);

  const moveToBag = (id) => {
    addToCart(id, 1, true);
    toggleWishlist(id);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 md:py-20" data-testid="wishlist-page">
      <header className="mb-12">
        <p className="overline-label mb-4">Saved Pieces</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tight">Your LAMSAH Wishlist</h1>
      </header>

      {!loading && items.length === 0 ? (
        <div className="py-24 text-center" data-testid="wishlist-empty">
          <Heart className="w-8 h-8 text-taupe mx-auto" strokeWidth={1} />
          <p className="font-serif text-2xl mt-6">Your wishlist is waiting to be filled</p>
          <p className="text-sm text-espresso/60 mt-3">Tap the heart on any piece you love.</p>
          <Link to="/shop" className="btn-primary mt-8" data-testid="wishlist-shop-link">Discover Hijabs</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12">
          {items.map((p) => (
            <div key={p.id} data-testid={`wishlist-item-${p.id}`}>
              <div className="relative overflow-hidden bg-beige aspect-[4/5]">
                <Link to={`/product/${p.id}`}>
                  <img src={p.images[0]} alt={`${p.name} hijab in ${p.shade}`} loading="lazy" className="w-full h-full object-cover" />
                </Link>
                <button
                  data-testid={`wishlist-remove-${p.id}`}
                  aria-label="Remove from wishlist"
                  onClick={() => toggleWishlist(p.id)}
                  className="absolute top-3 right-3 w-9 h-9 rounded-full bg-ivory/90 flex items-center justify-center"
                >
                  <X className="w-4 h-4 text-espresso" strokeWidth={1.5} />
                </button>
              </div>
              <div className="pt-4 space-y-1">
                <h3 className="font-serif text-lg leading-snug">{p.name}</h3>
                <p className="text-[11px] uppercase tracking-[0.2em] text-taupe">{p.shade}</p>
                <p className="text-sm text-espresso/80">{inr(p.price)}</p>
                <button
                  data-testid={`move-to-bag-${p.id}`}
                  onClick={() => moveToBag(p.id)}
                  disabled={p.stock === 0}
                  className="mt-3 w-full inline-flex items-center justify-center gap-2 border border-espresso text-espresso px-4 py-3 text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-espresso hover:text-ivory disabled:opacity-40"
                >
                  <ShoppingBag className="w-3.5 h-3.5" strokeWidth={1.5} />
                  {p.stock === 0 ? "Sold Out" : "Move to Bag"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
